import React, { useState } from 'react';

export default function StickyFooter({ onNavigate, scale = 1, t, isRTL }) {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  const sf = t?.stickyFooter || {};

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0,
      background: 'rgba(0,49,137,0.95)',
      borderTop: '2px solid #0063CB',
      padding: '8px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 500,
      boxShadow: '0 -2px 12px rgba(0,49,137,0.15)',
      direction: isRTL ? 'rtl' : 'ltr',
    }}>
      <button onClick={() => onNavigate('onboarding')} style={{
        background: '#fff', color: '#003189',
        fontSize: 12 * scale, fontWeight: 700,
        padding: '7px 22px', borderRadius: 8, border: 'none',
        cursor: 'pointer', whiteSpace: 'nowrap',
        boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
      }}>
        {sf.cta || 'Test diagnostic gratuit →'}
      </button>
      <button
        onClick={() => setVisible(false)}
        title='Fermer'
        style={{
          position: 'absolute', right: 14,
          background: 'rgba(255,255,255,0.2)',
          border: '1.5px solid rgba(255,255,255,0.5)',
          color: '#fff', fontSize: 14, fontWeight: 700,
          width: 28, height: 28, borderRadius: 6,
          cursor: 'pointer', display: 'flex',
          alignItems: 'center', justifyContent: 'center',
          lineHeight: 1,
        }}>×</button>
    </div>
  );
}
